import { AppEvents } from './AppEvents';
export const DefaultDeviceType = 'Default';
export var UserIdTypes;
(function (UserIdTypes) {
    UserIdTypes[UserIdTypes["Usual"] = 0] = "Usual";
    UserIdTypes[UserIdTypes["Encrypted"] = 1] = "Encrypted";
})(UserIdTypes || (UserIdTypes = {}));
;
export const ValidateRules = {
    Required: 'required',
    Email: 'email',
    Equals: 'equals',
    password: 'password',
    MaxLength: 'maxLength',
    Pattern: 'pattern',
    Password: 'password',
    PhonePart: 'phonepart',
    LessThan: 'lessThan',
    LessThanDate: 'lessThanDate',
    GreaterOrEqualThan: 'greaterOrEqualThan',
    GreaterOrEqualThanDate: 'greaterOrEqualThanDate'
};
export const ViewTypes = {
    Conversation: 'Conversation',
    Meter: 'Meter'
};
export const AnalyticsEvents = [
    AppEvents.Init,
    AppEvents.Run,
    AppEvents.Finish,
    AppEvents.MeterLevelSet,
    AppEvents.ConversationDetermined,
    AppEvents.ConversationExpired,
    AppEvents.AdblockFound,
    AppEvents.NotAuthorized,
    AppEvents.LoggedIn,
    AppEvents.ActionShow,
    AppEvents.ActionClosed,
    AppEvents.ButtonClick,
    AppEvents.NewsdayButtonClick,
    AppEvents.PaywallShown,
    AppEvents.FlittzPaywallShown,
    AppEvents.FlittzPaywallClosed,
    AppEvents.FlittzButtonClick,
    AppEvents.LoginShown,
    AppEvents.LoginClosed,
    AppEvents.LoginSuccess,
    AppEvents.LoginError,
    AppEvents.ActivationFormShown,
    AppEvents.ActivationLoginStepShown,
    AppEvents.ActivationLoginStepClosed,
    AppEvents.ActivationLinkStepShown,
    AppEvents.ActivationLinkStepClosed,
    AppEvents.ActivationLinkStepSubmitted,
    AppEvents.ActivationLinkSuccessStepShown,
    AppEvents.ActivationLinkSuccessStepClosed,
    AppEvents.ActivationLinkErrorStepShown,
    AppEvents.ActivationLinkErrorStepClosed,
    AppEvents.ActivationFormClosed,
    AppEvents.AccessTemplateShown,
    AppEvents.AccessTemplateClosed,
    AppEvents.AccessGranted,
    AppEvents.AccessDenied,
    AppEvents.LoadError,
    AppEvents.CriticalError,
    AppEvents.NewsletterArrival,
    AppEvents.ViewsAutoReset,
    AppEvents.ActionNotFound,
    AppEvents.ConversationNotFound,
    AppEvents.NewsletterArrival,
    AppEvents.NewsletterSignUp,
    AppEvents.NewsletterSignUpFails,
    AppEvents.ActivationAccountCreated,
    AppEvents.ChangedDeviceId,
    AppEvents.CustomTrackedEvent,
    AppEvents.NxtError
];
export var MaskingMethods;
(function (MaskingMethods) {
    MaskingMethods["Trim"] = "trim";
    MaskingMethods["Blur"] = "blur";
    MaskingMethods["Fade"] = "fade";
    MaskingMethods["FadeAndTrim"] = "fadeTrim";
})(MaskingMethods || (MaskingMethods = {}));
export var FadeTrimMethods;
(function (FadeTrimMethods) {
    FadeTrimMethods["AllowedCharacters"] = "allowedCharacters";
    FadeTrimMethods["ContainerHeight"] = "containerHeight";
})(FadeTrimMethods || (FadeTrimMethods = {}));
export var TemplateAttr;
(function (TemplateAttr) {
    TemplateAttr["Step"] = "data-nxt-template-step";
    TemplateAttr["SubStep"] = "data-nxt-template-substep";
})(TemplateAttr || (TemplateAttr = {}));
export var StorageKeys;
(function (StorageKeys) {
    StorageKeys["StorageAvialable"] = "nxt_avls";
})(StorageKeys || (StorageKeys = {}));
